import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import Spinner from "../../../../components/Spinner";
import axioPath from "../../../../../api/axioPath";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";
import { Heading, TableWrapper } from "web/pages/private/Admin/adminStyled";
import styled from "styled-components";
import { downloadFile } from 'redux/actions/helper/downloadFile';

function LanguageLocalization() {
  let history = useHistory()
  let dispatch = useDispatch()
  const loaderVisible = useSelector((state) => state.appReducer.loaderVisible);
  const adminRoles = useSelector(state => state.admin.adminRoles)
  const buttonStyle = {
    background: "linear-gradient(to bottom, #61b01f 0%,#27911b 100%)",
    color: "white",
    whiteSpace: "nowrap",
    border: 0,
    borderRadius: "5px",
    padding: "5px 15px",
    margin: "2px",
    cursor: "pointer",
  };

  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [modalMessage, setModalMessaage] = useState("");

  useEffect(() => {
    let userRole = localStorage.getItem('accountType')
    let appUserRolesList = ['Both', 'Buyer', 'Seller']
    if (userRole !== 'Admin') {
      if (appUserRolesList.includes(userRole)) history.push('/dashboard')
      else history.push('/sign-in')
      window.location.reload();
    }
  }, [])

  const handleFile = (e) => {
    // Getting the files from the input
    let files = e.target.files;
    if (files[0].name.includes(".xlsx")) {
      setFile({ files });
      setFileName(files[0].name);
    } else {
      setModalMessaage("File format has to be excel (.xlsx)");
      setModal(true);
    }
  };

  const handleToggle = () => {
    setModal(!modal);
  };

  const handleUpload = (e) => {
    setLoading(true);
    let files = file;
    let formData = new FormData();
    formData.append("file", files.files[0]);
    const token = localStorage.getItem("token");
    let newUrl = "/user/language/updateContent"
    axioPath.post(newUrl, formData, {
      headers: {
        Authorization: token,
      },
    }).then((response) => {
      if (response.data && response.data.status === 'SUCCESS') {
        setLoading(false);
        setModalMessaage(response.data.message);
        setModal(true);
      } else {
        setLoading(false);
        if (response.data.message === "Unauthorized (Invalid token)") {
          localStorage.removeItem('token')
          history.push('/sign-in')
          window.location.reload(false);
        } else {
          setModalMessaage(response.data.message)
          setModal(!modal)
        }
      }
    }).catch((ex) => {
      setLoading(false);
    });
  };

  const handleDownload = () => {
    const fileUrl = process.env.REACT_APP_API_URL + "/user/language/getLanguageFileFromS3";
    dispatch(downloadFile('language-content-file.xlsx', fileUrl, localStorage.getItem('token')));
  };

  return (
    <>
      {(adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('LANGUAGE_LOCALIZATION'))) ?
        <>
          <TableWrapper>
            {(loading || loaderVisible) && <Spinner />}
            <Heading>
              <h3>Upload Language Contents</h3>
            </Heading>

            <UploadFileWrapper>
              <label class="custom-file-upload">
                <input
                  style={{ width: "100px" }}
                  type="file"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  multiple={false}
                  onChange={handleFile}
                  name="hi"
                />
                <i class="fa fa-cloud-upload"></i> Choose File
              </label>
              <p>{fileName}</p>
            </UploadFileWrapper>
            <ButtonWrapper>
              <button
                style={buttonStyle}
                onClick={handleUpload}
                disabled={file === null ? true : false}
              >
                Upload
              </button>
              <button style={buttonStyle} onClick={handleDownload}>
                Download the latest document
              </button>
            </ButtonWrapper>
            <Modal isOpen={modal}>
              <ModalBody>{modalMessage}</ModalBody>
              <ModalFooter>
                <Button color="primary" onClick={handleToggle}>
                  OK
                </Button>
              </ModalFooter>
            </Modal>
          </TableWrapper>
        </>

        :

        <p>You are not authorized to view this page.</p>
      }
    </>
  );
}

export default LanguageLocalization;

const UploadFileWrapper = styled.div`
    padding: 15px;
    display: flex;
    gap: 15px;
    flex-wrap: wrap;
    input[type="file"] {
      display: none;
    }
    .custom-file-upload {
      background: linear-gradient(rgb(97, 176, 31) 0%, rgb(39, 145, 27) 100%);
      color: white;
      white-space: nowrap;
      border: 0px;
      border-radius: 5px;
      padding: 5px 15px;
      cursor: pointer;
      margin: 0;
      display: flex;
      align-items: center;
      gap: 5px;
    }
  `;
const ButtonWrapper = styled.div`
    padding: 15px;
    display: flex;
    gap: 10px;
    padding: 15px;
    flex-wrap: wrap;
  `;